import React from 'react'
import Typography from '@ui/typography'
import { Platform, View } from 'react-native'
import { useTranslation } from 'react-i18next'
import FormattedText from '@ui/typography/FormattedText'
import cn from '@ui/utils/cn'

const getKeyPath = ({ path, ns }: { path: string; ns?: string }): string =>
  ns ? `${ns}:${path}` : path

interface Props {
  ns: string
  path: string
}

export default function ModalHeader({ ns = 'translations', path }: Props) {
  const { i18n, t } = useTranslation(ns)

  const descPath = getKeyPath({ path: `${path}.desc`, ns })
  const hasDescription = i18n.exists(descPath)

  return (
    <View
      className={cn(
        'items-center gap-4 pt-4',
        Platform.select({ default: 'gap-6 pt-4', web: 'gap-6 pt-8' })
      )}
    >
      <Typography variant="XLB" className="text-center">
        {t(`${path}.title`)}
      </Typography>
      {hasDescription && (
        <FormattedText
          variant={Platform.select({ default: 'MD', web: 'MD' })}
          className={cn(
            'color-desc text-center',
            Platform.OS === 'web' && 'px-16'
          )}
          ns={ns}
          i18nKey={`${path}.desc`}
        />
      )}
    </View>
  )
}
